import {
  Box,
  CircularProgress,
  LinearProgress,
  Paper,
  Typography,
} from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import React, { useEffect, useState, useRef } from 'react';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';

import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';

import { useCrewCalender } from './StoreCrewCalendar';

import ShiftDetailsForm, { DetailRef } from './ShiftDetails';
import Resources, { ResourceRef } from './Resources';

import AlertMessageComponent from '../../components/AlertMessageComponent';
import MobileAssets, { AssetsRef } from './MobileAssets';
import Labours, { LabourRef } from './Labours';
import { ToastMessage } from '../../Models/ToastMessage';

import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import ButtonComponent from '../../components/form/ButtonComponent';
import Tasks, { TaskRef } from './Tasks';
import { GoogleMapProvider } from '../../components/GoogleMapContext';
import tabStore from './tabStore';

import StatusActivity from './StatusActivity';
import { downloadFile, getShiftStatusText } from '../../utils/storageUtil';

const ShiftReport: React.FC = () => {
  const tabLabels = [
    'Details',
    'Resources',
    'Mobile Assets',
    'Labour',
    'Tasks',
    'Status',
  ];

  const [tabIndex, setTabIndex] = useState(0);

  const isInitialLoad = useRef(true);
  const [shiftLoadig, setShiftLoading] = useState<boolean>(false);

  const { crewId, shiftId } = useParams<{ crewId: any; shiftId: any }>();
  const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);
  const [projectList, setProjectList] = useState<any[]>([]);
  const [crewList, setCrewList] = useState<any[]>([]);
  const [mobileAssetsList, setMobileAssetsList] = useState<any[]>([]);
  const [laboursList, setLaboursList] = useState<any[]>([]);
  const [tasksList, setTasksList] = useState<any[]>([]);
  const [inProgress, setInProgress] = useState(false);
  const [downloading, setDownloading] = useState<boolean>(false);
  const [saving, setSaving] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const formRef = useRef<DetailRef>(null);
  const resourceRef = useRef<ResourceRef>(null);
  const assetsRef = useRef<AssetsRef>(null);
  const labourRef = useRef<LabourRef>(null);
  const taskRef = useRef<TaskRef>(null);

  const [pendingTab, setPendingTab] = useState<number>(-1);
  const {
    crews,
    setCrews,
    setQuoteDetails,

    setResourceListItems,
    openSuccess,
    setOpenSuccess,
    successMessage,
  } = useCrewCalender();
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const { formData } = tabStore;
  const [httpError, setHttpError] = useState<ToastMessage>({
    message: successMessage,
    errorColor: 'success',
    open: openSuccess,
  });
  const loadData = async () => {
    if (crewId) {
      setInProgress(true);
      if (projectList.length === 0) await fetchProjects();
      if (crews.length === 0) {
        if (crewList.length === 0) {
          await fetchCrews();
        }
      } else {
        setCrewList(crews);
      }

      setInProgress(false);
    }
  };
  useEffect(() => {
    if (isInitialLoad.current) {
      loadData();
      isInitialLoad.current = false;
    }
  }, [crewId]);

  useEffect(() => {
    if (shiftId) {
      if (!currentRecord) fetchShift(shiftId);
      isInitialLoad.current = false;
    }
  }, [shiftId]);
  const fetchShift = async (shiftId: any) => {
    try {
      setShiftLoading(true);
      const response = await HttpServices.get(
        Constants.apiURL + Constants.shiftURL + '/' + shiftId,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        setCurrentRecord(response.data);
        fetchQuoteDetails(response.data.project.quoteId);
      }
      setShiftLoading(false);
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
      setShiftLoading(false);
    }
  };
  const getResourceList = async () => {
    try {
      const response = await HttpServices.get(
        Constants.apiURL + Constants.resourcesURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { isActive: '1' }
      );
      if (response.success) {
        const resourceRecords = response.data.paginateRecords;
        if (resourceRecords.length > 0) {
          setResourceListItems(resourceRecords);
        }
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
    }
  };
  const fetchProjects = async () => {
    try {
      const response = await HttpServices.get(
        Constants.apiURL + Constants.projectDashboardsURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1 }
      );
      if (response.success) {
        console.log(response);
        setProjectList(
          response.data.paginateRecords
            .map((item: any) => ({
              ...item,
              id: item.projectInternalId,
              label: item.projectId + ' - ' + item.projectName,
            }))
            .sort((a: any, b: any) => a.label.localeCompare(b.label))
        );
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
    }
  };
  const fetchCrews = async () => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.crewsURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {}
      );
      console.log(response);
      if (response.data) {
        setCrewList(response.data.paginateRecords);
        setCrews(response.data.paginateRecords);
      } else {
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
    }
  };
  const fetchQuoteDetails = async (quoteId: any) => {
    try {
      const response = await HttpServices.get(
        Constants.apiURL + Constants.quoteURL + '/' + quoteId,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        setQuoteDetails(response.data);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
    }
  };

  const changeTabHandler = (event: React.SyntheticEvent, newIndex: number) => {
    event.preventDefault();
    if (newIndex > 0 && !currentRecord) {
      return false;
    }
    if (
      currentRecord &&
      (currentRecord?.shiftStatusId === 0 ||
        currentRecord.shiftStatusId === 2) &&
      formData.tab1Field !== ''
    ) {
      setPendingTab(newIndex);
      setConfirmDailogOpen(true);

      return;
    } else {
      tabStore.updateField('tab1Field', '');
      handleTabChangeEvent(newIndex);
      return;
    }
  };
  const handleTabChangeEvent = async (newIndex: number) => {
    setTabIndex(newIndex);
    if (newIndex === 1) {
      await getResourceList();
    }
    if (newIndex === 2) {
      if (mobileAssetsList.length === 0) await fetchMobileAssets();
    }

    if (newIndex === 3) {
      if (laboursList.length === 0) await fetchLabourList();
    }
    if (newIndex === 4) {
      if (tasksList.length === 0) await fetchTasksList();
    }
  };
  const fetchMobileAssets = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.mobileAssetsURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { limit: -1, serach: '' }
      );
      console.log(response);
      if (response.data) {
        setMobileAssetsList(response.data.paginateRecords);
      } else {
        setMobileAssetsList([]);
      }
      setInProgress(false);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
    }
  };
  const fetchTasksList = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.shiftURL}/${currentRecord.shiftId}/task`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      console.log(response);
      if (response.data) {
        setTasksList(response.data);
      } else {
        setTasksList([]);
      }
      setInProgress(false);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
    }
  };
  const fetchLabourList = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.labourURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        { limit: -1, serach: '' }
      );
      console.log(response);
      if (response.data) {
        setLaboursList(response.data.paginateRecords);
      } else {
        setLaboursList([]);
      }
      setInProgress(false);
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
    }
  };
  const goBack = async () => {
    tabStore.updateField('tab1Field', '');
    navigate('/schedules/crews-schedule');
  };
  const goRefresh = async () => {
    fetchShift(shiftId);
  };
  const updateShiftStatus = async (record: any) => {
    if (
      parseInt(currentRecord['shiftStatusId']) !==
      parseInt(record.newShiftStatusId)
    ) {
      const endpoint = Constants.apiURL + Constants.shiftURL;
      await HttpServices.put(endpoint, record, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
    }
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  const dialogConfirmation = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <h2>
          If you leave this tab, your changes will be lost. What would you like
          to do?
        </h2>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <ButtonComponent
            errors={[]}
            keyName="okbuttonconfirm"
            disabled={saving}
            label={saving ? 'Saving....' : 'Save Changes'}
            onClick={async () => {
              let statusSaveId: any = 0;
              setSaving(true);
              var refSave: any = null;
              if (tabIndex === 0) {
                refSave = formRef;
              }
              if (tabIndex === 1) {
                refSave = resourceRef;
              }
              if (tabIndex === 2) {
                refSave = assetsRef;
              }
              if (tabIndex === 3) {
                refSave = labourRef;
              }
              if (tabIndex === 4) {
                refSave = taskRef;
              }
              if (currentRecord.shiftStatusId === 2) {
                statusSaveId = 3;
              }
              await refSave.current?.handleSave(statusSaveId);
              setSaving(false);
              tabStore.updateField('tab1Field', '');
              handleTabChangeEvent(pendingTab);
              setConfirmDailogOpen(false);
            }}
          />
          <ButtonComponent
            errors={[]}
            keyName="okbuttonconfirm"
            label="Discard Changes"
            disabled={saving}
            onClick={() => {
              tabStore.updateField('tab1Field', '');
              handleTabChangeEvent(pendingTab);
              setConfirmDailogOpen(false);
            }}
          />
          <ButtonComponent
            errors={[]}
            keyName="cancelbuttonconfirm"
            label="Cancel"
            disabled={saving}
            onClick={() => {
              setConfirmDailogOpen(false);
            }}
          />
        </Box>
      </Box>
    );
  };
  const fetchShiftReportDocuments = async () => {
    try {
      setDownloading(true);
      const URL = `${Constants.apiURL}${Constants.documentPDFsURL}/fetchShiftReportPDF/${shiftId}`;
      const response = await HttpServices.get(URL, {
        headers: {
          Authorization: 'Bearer ' + getAdmin(),
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      });

      setDownloading(false);
      if (response) {
        downloadFile(response, 'Shift_' + shiftId + '.pdf');
        window.open(response.data, '_blank');
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      setDownloading(false);
      console.error(`GET ERROR:`, error);
    }
  };
  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <div
              onClick={() => {
                goBack();
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <UTurnLeftIcon
                sx={{
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
              />
              <Typography>Back</Typography>
            </div>

            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  padding: '24px 16px 16px 16px',
                  mb: 2,
                  display: 'grid',
                  gap: '32px',
                  overflowX: 'scroll',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography component={'h6'}>
                    Shift Report
                    {currentRecord && (
                      <span
                        style={{
                          backgroundColor: '#001e3c',
                          color: '#00e5ff',
                          borderRadius: '25px',
                          fontWeight: 600,
                          padding: '4px 20px',
                          marginLeft: '10px',
                          fontSize: '12px',
                          width: '90%',
                          textAlign: 'center',
                        }}
                      >
                        {getShiftStatusText(
                          currentRecord ? currentRecord['shiftStatusId'] : 0
                        )}
                      </span>
                    )}
                  </Typography>
                  <ButtonComponent
                    onClick={() => {
                      fetchShiftReportDocuments();
                    }}
                    label={
                      downloading ? 'Downloading...' : 'Download Shift Report'
                    }
                  />
                </Box>

                <Box sx={{ width: '100%' }}>
                  <Box
                    sx={{ borderBottom: 1, borderColor: 'divider', mb: '0px' }}
                  >
                    <Tabs value={tabIndex} onChange={changeTabHandler}>
                      {tabLabels.map((label: any, index: number) => {
                        return (
                          <Tab
                            disabled={inProgress}
                            label={label}
                            {...a11yProps(index)}
                          />
                        );
                      })}
                    </Tabs>
                  </Box>

                  <Box sx={{ position: 'relative', minHeight: '600px' }}>
                    {inProgress && (
                      <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <LinearProgress />
                      </Box>
                    )}
                    {shiftLoadig && (
                      <Box
                        sx={{
                          width: '100%',
                          textAlign: 'center',
                          position: 'absolute',
                          zIndex: 999,
                          marginTop: '10%',
                        }}
                      >
                        <CircularProgress
                          disableShrink
                          sx={{ margin: '0 auto' }}
                        />
                      </Box>
                    )}

                    {tabIndex === 0 && !inProgress && (
                      <GoogleMapProvider>
                        <ShiftDetailsForm
                          crewId={crewId}
                          ref={formRef}
                          crewList={crewList}
                          currentRecord={currentRecord}
                          projectList={projectList}
                          goBack={goBack}
                          saveSuccess={(data: any) => {
                            setCurrentRecord(data);
                            fetchQuoteDetails(data.project.quoteId);
                          }}
                        />
                      </GoogleMapProvider>
                    )}
                    {tabIndex === 1 && (
                      <Resources
                        goBack={goBack}
                        updateShiftStatus={updateShiftStatus}
                        currentRecord={currentRecord}
                        ref={resourceRef}
                        goRefresh={goRefresh}
                      />
                    )}
                    {tabIndex === 2 && (
                      <MobileAssets
                        ref={assetsRef}
                        goBack={goBack}
                        goRefresh={goRefresh}
                        updateShiftStatus={updateShiftStatus}
                        mobileAssetsList={mobileAssetsList}
                        currentRecord={currentRecord}
                      />
                    )}
                    {tabIndex === 3 && (
                      <Labours
                        ref={labourRef}
                        goRefresh={goRefresh}
                        goBack={goBack}
                        updateShiftStatus={updateShiftStatus}
                        currentRecord={currentRecord}
                      />
                    )}
                    {tabIndex === 4 && (
                      <Tasks
                        ref={taskRef}
                        goBack={goBack}
                        goRefresh={goRefresh}
                        updateShiftStatus={updateShiftStatus}
                        tasksList={tasksList}
                        currentRecord={currentRecord}
                        loadTasks={() => {
                          fetchTasksList();
                        }}
                      />
                    )}
                    {tabIndex === 5 && (
                      <StatusActivity
                        goBack={goBack}
                        currentRecord={currentRecord}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </Paper>
          </div>
        </div>
      </section>
      <AlertMessageComponent
        type={httpError.errorColor}
        open={httpError.open}
        handleClose={() => {
          setHttpError({ open: false, message: '', errorColor: 'error' });
          setOpenSuccess(false);
        }}
        message={httpError.message}
      />
      {
        <SimpleDialogComponent
          title={'You have unsaved changes'}
          dialogContent={dialogConfirmation()}
          open={confirmDailogOpen}
          handleClose={() => {
            setConfirmDailogOpen(false);
          }}
        />
      }
    </Box>
  );
};

export default ShiftReport;
